export default __webpack_public_path__ + "static/media/Peer.fbfd830c.svg";